import { Button, Flex } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, layout } from 'styled-system';

export const Image = styled.img<LayoutProps>`
  ${layout};

  ${tokens.mediaQueries.s} {
    width: 100%;
    height: 100%;
  }
`;

export const Content = styled(Flex)`
  max-width: 610px;
`;

export const Title = styled.h1`
  margin-bottom: ${tokens.space.large};
  text-align: center;
`;

export const Description = styled.p`
  font-family: ${tokens.fonts.primary};
  font-size: ${tokens.fontSizes.l};
  line-height: ${tokens.lineHeights.l};
  color: ${tokens.colors.grayDarkest};
  text-align: center;
  margin-bottom: ${tokens.space.large};
`;

export const ReloadButton = styled(Button)`
  font-family: ${tokens.fonts.primary};
`;

export const Actions = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: ${tokens.space.regular};
`;
